import React from 'react'
import {
  IconButton,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverHeader,
  PopoverBody,
  PopoverArrow,
  PopoverCloseButton,
  Text,
  Grid,
  VStack,
  Center,
  GridItem,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Divider,
} from '@chakra-ui/react'
import { MdOutlineLeaderboard } from 'react-icons/md'

const Stats = ({stats}) => {
  let categoryStats = []
  Object.keys(stats.categoryPerformance).forEach(e =>{
    if(stats.categoryPerformance[e] > 0){
      categoryStats.push(e)
    }
  });
  categoryStats.sort((a,b) => {
    return(stats.categoryPerformance[b]-stats.categoryPerformance[a])
  })
  return (
    <>
      <Popover placement='bottom-end' arrowSize={12}>
      <PopoverTrigger>
      <IconButton isRound variant={'ghost'} aria-label='Stats' icon={<MdOutlineLeaderboard/>}/>
      </PopoverTrigger>
      <PopoverContent >
        <PopoverHeader fontWeight='semibold'>Statistics</PopoverHeader>
        <PopoverArrow />
        <PopoverCloseButton />
        <PopoverBody>
          <Center>
          <VStack maxW={'100%'}>
          <Grid templateColumns='repeat(2, 1fr)' gap={6}>
            <GridItem>
              <VStack>
                <Text>Games Played</Text>
                <Text>{stats.gamesPlayed}</Text>
              </VStack>
            </GridItem>
            <GridItem>
              <VStack>
                <Text>Average Score</Text>
                <Text>{stats.averagePerformance.toFixed(2)}</Text>
              </VStack>
            </GridItem>
          </Grid>
          <Divider />
          <TableContainer >
            <Table size='sm' maxW={'100%'}>
              <Thead>
                <Tr>
                  <Th>Best Categories</Th>
                </Tr>
              </Thead>
              <Tbody>
                {categoryStats.slice(0,5).map((data,index )=> {
                  return(
                    <Tr key={index}>
                      <Td>{data}</Td>
                    </Tr>
                  )
                })}
              </Tbody>
            </Table>
          </TableContainer>
          </VStack>
          </Center>
        </PopoverBody>
      </PopoverContent>
    </Popover>
    </>
  )
}

export default Stats
